// @ts-ignore
import * as Surplus from "surplus";

import { URIResources } from "../.generated/R";

export interface ImgProps extends Omit<JSX.HTMLAttributes<HTMLImageElement>, "src"> {
    src: URIResources;
}

export function Img(props: ImgProps) {
    if (!props.alt) (props as any).alt = "";
    return <img {...props} style={{ width: `${props.width}px`, height: `${props.height}px` }} />;
}

export function PixelImg(props: ImgProps & JSX.HTMLAttributes<HTMLImageElement>) {
    let clazz = props.class;
    delete props.class;
    let combClass = "crisp-pixels" + (clazz !== undefined ? " " + clazz : "");
    return <Img class={combClass} {...props} />;
}

export interface ImgButtonProps {
    "aria-label": string;
}
